import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Auth0Provider } from "@auth0/auth0-react";
import "./styles.css";

import App from "./js/App";
import Auth from "./js/Auth";


const root = createRoot(document.getElementById("root"));

document.title = "OLCA Dev";

//old code
//root.render(
//  <StrictMode>
//    <Auth />
//  </StrictMode>
//);

//new code
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={{ redirect_uri: window.location.origin }}
      cacheLocation="localstorage"
    >
      <Auth />
    </Auth0Provider>
  </React.StrictMode>
);
